import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import withPermissions from "../../components/WithPermissions";
import PageHeader from "../../components/PageHeader";
import mainHelper, {
    apiCall,
    getBranches,
    getEmployes,
    getRoles,
} from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
class UserAdd extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            branches: [],
            roles: [],
            loading: false,
            formData: {
                name: '',
                surname: '',
                email: '',
                phone: '',
                status: 1,
                branch_id: '',
                role: '',
                password: '',
                password_confirmation: ''
            }
        }
    }
    async componentDidMount() {
        const response = await getBranches();
        const roles = await getRoles();
        this.setState({ branches: response, roles: roles });
    }
    setEmployees = async () => {
        const employees = await getEmployes();
        localStorage.setItem('employees', JSON.stringify(employees));
    }
    handleChange = (e) => {
        const { id, name, value, type, checked } = e.target;
        const key = name || id;

        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                [key]: type === 'radio' ? (checked ? parseInt(value) : 0) : value
            }
        }));
    }
    handleSubmit = async (e) => {
        e.preventDefault();
        this.setState({ loading: true });
        const { formData } = this.state;
        const userFormData = new FormData();
        Object.keys(this.state.formData).forEach(key => {
            userFormData.append(key, formData[key]);
        });
        try {
            const response = await apiCall('business/user/add', 'post', userFormData);
            this.setState({ loading: false });
            mainHelper.toastMessage(response.status, response.message)
        } catch (e) {
            this.setState({ loading: false });
        }

    }
    render() {
        const { loading, branches, roles } = this.state;
        const { userPermissions } = this.props;
        const userHasNewUserPermission = userPermissions.includes('new user');
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Kullanıcı Ekle"
                            Breadcrumb={[
                                { name: "Kullanıcılar", navigate: "users" },
                                { name: "Yeni Kullanıcı Ekle", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <div className="col-lg-12">
                                <div className="card">
                                    <form onSubmit={this.handleSubmit}>
                                        <div className="body">
                                            <h6>Temel Bilgiler</h6>
                                            <div className="row clearfix">
                                                <div className="col-lg-6 col-md-12">
                                                    <div className="form-group">
                                                        <input
                                                            id="name"
                                                            className="form-control"
                                                            placeholder="Ad"
                                                            type="text"
                                                            onChange={this.handleChange}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <input
                                                            id="surname"
                                                            className="form-control"
                                                            placeholder="Soyad"
                                                            type="text"
                                                            onChange={this.handleChange}
                                                        />
                                                    </div>

                                                    <div className="form-group">
                                                        <input
                                                            id="password"
                                                            className="form-control"
                                                            placeholder="Şifre"
                                                            type="password"
                                                            onChange={this.handleChange}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <input
                                                            id="password_confirmation"
                                                            className="form-control"
                                                            placeholder="Şifre tekrar"
                                                            type="password"
                                                            onChange={this.handleChange}
                                                        />
                                                    </div>

                                                </div>
                                                <div className="col-lg-6 col-md-12">
                                                    <div className="form-group">
                                                        <select id="role" className="form-control"
                                                            onChange={this.handleChange}>
                                                            <option value="">Rol Seçiniz</option>
                                                            {roles.map(item => (
                                                                <option key={item.id}
                                                                    value={item.name}>{item.name.split('_')[0]}</option>
                                                            ))}
                                                        </select>
                                                    </div>

                                                    <div className="form-group">
                                                        <select id='branch_id' className="form-control"
                                                            onChange={this.handleChange}>
                                                            <option value="">Şube Seçiniz</option>
                                                            {branches.map(item => (
                                                                <option key={item.id}
                                                                    value={item.id}>{item.name}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="form-group">
                                                        <input
                                                            id="email"
                                                            className="form-control"
                                                            placeholder="Email"
                                                            type="email"
                                                            onChange={this.handleChange}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <input
                                                            id="phone"
                                                            className="form-control"
                                                            placeholder="Telefon"
                                                            type="text"
                                                            onChange={this.handleChange}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="body">
                                                <div className="row clearfix justify-content-center">
                                                    <div className="col-lg-6 col-md-12">
                                                        {loading ? (
                                                            <button className="btn btn-outline-primary btn-block"
                                                                disabled={true}
                                                                style={{ textAlign: "-webkit-center" }}>
                                                                Lütfen Bekleyin...<ReactLoading type="spin"
                                                                    width={'24px'}
                                                                    height={'24px'}
                                                                    color="#268bd2"></ReactLoading>
                                                            </button>
                                                        ) :
                                                            <button disabled={!userHasNewUserPermission}
                                                                className="btn btn-outline-primary btn-block"
                                                                type="submit">
                                                                Kaydet
                                                            </button>}

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ ioTReducer }) => ({
    isSecuritySystem: ioTReducer.isSecuritySystem,
});

export default withPermissions(withRouter(connect(mapStateToProps, {})(UserAdd)));
